import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class Titles {
	public readonly titles = {
		"/Home": "Portal Home",
		"/Home/UserManagement": "User Management",
		"/Home/UserManagement/addUser": "Add User",
		"/Home/Profile": "Profile",
		"/Home/ChangeSession": "Change Session",
		"/Home/AlertConfiguration": "Alert Configuration",
		"/Home/Navigate": "Navigate",
		"/Home/Settings": "Settings",
		"/CDR": "Data Usage",
		"/CDR/Devices": "Devices",
		"/CDR/Devices/Details": "Device Details",
		"/CDR/Alerts": "Usage Alerts",
		"/KeepAlive": "Keep Alive",
		"/KeepAlive/Devices": "Devices",
		"/KeepAlive/Devices/Details": "Device Details",
		"/KeepAlive/RingfenceLogs": "Ringfence Logs",
		"/KeepAlive/Map": "Map",
		"/Reports": "Reports",
		"/Reports/1": "Total Device Usage Report",
		"/Reports/2": "Inventory Report",
		"/Reports/3": "Sim Usage Report",
		"/Reports/4": "Device Status Report",
		"/Reports/5": "Inventory Report",
		"/Reports/6": "Inventory Report",
		"/Reports/8": "Device Usage By Interval Report",
		"/Reports/9": "Keep Alive Activity Report",
		"/Reports/10": "Device Usage By APN Report",
		"/Reports/11": "Keep Alive Event Report",
		"/Reports/12": "Keep Alive Device State Report",
		"/Mikrotik": "Router Management",
		"/Mikrotik/Devices": "Devices",
		"/Mikrotik/Devices/Details": "Details",
		"/Mikrotik/Map": "Map",
		"/Relay": "Transaction Monitoring",
	};
}
